/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popRobot.vue?vue&type=template&id=a8c6fdd8&scoped=true"
import script from "./popRobot.vue?vue&type=script&lang=js"
export * from "./popRobot.vue?vue&type=script&lang=js"
import style0 from "./popRobot.vue?vue&type=style&index=0&id=a8c6fdd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c6fdd8",
  null
  
)

export default component.exports